import React from "react";
import { array, object, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import RelatedStory from "../../atoms/RelatedStory";
import { staticTexts } from "../../utils/Translate";

import "./relatedStories.m.css";

const RelatedStories = ({ stories, publisherAttributes, isMobile, story }) => {
  const relText =
    story && story["story-template"] === "photo"
      ? staticTexts(publisherAttributes.lang).morePhotoStories
      : staticTexts(publisherAttributes.lang).relatedStories;
  const wrapperClass =
    story && story["story-template"] === "photo" ? "photo-related-stories-wrapper" : "related-stories-wrapper";
  const storyClass = story && story["story-template"] === "photo" ? "photo-related-story" : "related-story";
  return (
    <div styleName="related-stories">
      <Headline
        text={relText}
        headerLevel={3}
        headlineType={6}
        className={`heading ${publisherAttributes.lang === "en" ? "en-heading" : ""}`}
      />
      <div styleName={wrapperClass}>
        {stories.map((story) => {
          return (
            <RelatedStory
              story={story}
              key={story.id}
              isMobile={isMobile}
              lang={publisherAttributes.lang}
              storyClass={storyClass}
            />
          );
        })}
      </div>
    </div>
  );
};

RelatedStories.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
  isMobile: bool,
  story: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(RelatedStories);
